export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-shield-check-line',
      title: 'Licensed & Insured',
      description: 'Fully licensed contractors with comprehensive insurance coverage. Our team meets all Massachusetts state requirements and maintains the highest industry certifications for home accessibility modifications and safety installations.'
    },
    {
      icon: 'ri-time-line',
      title: 'Fast Installation',
      description: 'Professional safety upgrades installed in days, with many projects completed in just twenty-four hours. Our streamlined process ensures your home is reinforced quickly without compromising on quality.'
    },
    {
      icon: 'ri-award-line',
      title: 'Quality Guaranteed',
      description: 'Every installation backed by our comprehensive warranty and satisfaction guarantee. We use premium materials and proven techniques to ensure your modifications last for years while maintaining their safety and functionality.'
    }
  ];

  return (
    <section id="benefits" className="bg-white py-12 sm:py-16 md:py-20 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <div className="text-[#D4AF37] text-xs sm:text-sm font-semibold tracking-wider mb-3 sm:mb-4">
            THE SAFESTAY DIFFERENCE
          </div>
          <h2 className="text-[#1A2B4A] text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold px-4">Peace of Mind Included</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-7">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-[#FAF9F7] rounded-xl sm:rounded-2xl p-6 sm:p-8 lg:p-9 hover:shadow-md transition-shadow duration-300"
            >
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-[#D4AF37] rounded-full flex items-center justify-center mb-5 sm:mb-7">
                <i className={`${benefit.icon} text-[#1A2B4A] text-2xl sm:text-3xl`}></i>
              </div>
              <h3 className="text-[#1A2B4A] text-xl sm:text-2xl font-bold mb-3 sm:mb-4">{benefit.title}</h3>
              <p className="text-gray-600 text-sm sm:text-base leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
